module.exports = __webpack_public_path__ + "static/media/44-clarks-cove.0edf7c59.jpg";